document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.js-gallery-youtube-launch').forEach(function(button) {
    button.addEventListener('click', function() {
      const targetVideo = document.querySelector(this.dataset.target);
      const src = this.dataset.src + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0";

      targetVideo.querySelector('.youtube-iframe').setAttribute('src', src);

      targetVideo.addEventListener('hide.bs.modal', function() {
        document.querySelectorAll('.youtube-iframe').forEach(function(iframe) {
          iframe.setAttribute('src', '');
        });
      });
    });
  });
  
  // Function to handle image loading - DRY implementation
  function loadCarouselImage(img) {
    const lazySrc = img.dataset.lazySrc;
    img.setAttribute('src', lazySrc);
    img.style.opacity = '0';
    
    img.onload = function() {
      const loader = this.nextElementSibling;
      if (loader) loader.style.display = 'none';
      this.style.opacity = '1';
      // Simulating the animate function with a simple transition
      this.style.transition = 'opacity 0.3s';
    };
  }

  document.querySelectorAll('.js-gallery-image-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      const index = Array.from(this.parentNode.children).indexOf(this);
      const targetID = this.dataset.modal;
      const modalElement = document.getElementById(targetID);
      
      modalElement.classList.add('open-gallery');
      document.body.classList.add('modal-open');
      
      const carousel = document.getElementById(targetID + '__carousel');
      
      // Assuming bootstrap carousel has pause method
      // May need to use bootstrap's JavaScript API directly depending on how it's implemented
      bootstrap.Carousel.getInstance(carousel).pause();
      
      // Set the active slide
      bootstrap.Carousel.getInstance(carousel).to(index);
      
      // Load the active image
      const activeImg = carousel.querySelector('.active img');
      loadCarouselImage(activeImg);
      
      // Handle slide events
      carousel.addEventListener('slid.bs.carousel', function() {
        const newActiveImg = this.querySelector('.active img');
        loadCarouselImage(newActiveImg);
      });
    });
  });

  document.querySelectorAll('.js-gallery-modal-close').forEach(function(closeButton) {
    closeButton.addEventListener('click', function() {
      document.querySelectorAll('.gallery-modal').forEach(function(modal) {
        modal.classList.remove('open-gallery');
      });
      document.body.classList.remove('modal-open');
    });
  });

});



